window.jQuery = require('jquery');
window.$ = jQuery;

// Common css files
require('./Css/grid.scss');
require('./Css/common.scss');
require('./Css/icons.scss');
require('./Css/layout.scss');
require('./Css/typography.scss');
require('./Css/sprites-base.scss');
require('./Css/sprites.scss');
require('./Css/header.scss');
require('./Css/buttons.scss');
require('./Css/forms.scss');
require('./Css/listing.scss');

require('./Css/advertisement.scss');
require('./Css/toolbar.scss');
require('./Css/jquery.fancybox.css');
require('./Js/postscribe.js');
require('./Js/jquery.validate.js');
require('./Js/jquery.fancybox.js');
require('./Js/tracking.js');
require('./Js/phoneMask.js');
require('./Js/mobi/toolbar.js');